module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/954db77158548ee8654dc468c9b6ccb4.png";